import { render, staticRenderFns } from "./settings-view.vue?vue&type=template&id=cc053e82&"
import script from "./settings-view.vue?vue&type=script&lang=ts&"
export * from "./settings-view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports